/**
 * ------------------------------------------------------------
 * @file KLCard 卡片
 * @author zianecui@gmail.com
 * ------------------------------------------------------------
 */

const Component = require('../../../ui-base/component');
const template = require('./index.html');
const _ = require('../../../ui-base/_');

/**
 * @class KLCard
 * @extend Component
 * @param {object}          [options.data]                        = 绑定属性
 * @param {string}          [options.data.class]                  => 补充class
 * @param {boolean}          [options.data.isShowLine]            => 控制展示title之前的竖线，默认展示出来
 * @param {boolean}          [options.data.isShowBtLine]          => 控制展示title下发的横线，默认不展示出来
 * @param {boolean}          [options.data.isIndent]              => 控制子模块的title是否缩进
 * @param {boolean}          [options.data.bordered]              => 控制card是否有边框
 * @param {boolean}          [options.data.disHover]              => 禁用鼠标悬停显示阴影
 */
const KLCard = Component.extend({
  name: 'kl-card',
  template,
  $tools: null,
  config() {
    _.extend(this.data, {
      title: '',
      isShowLine: true,
      isShowBtLine: true,
      isIndent: true,
    });
    this.supr();
  },
});

module.exports = KLCard;



// WEBPACK FOOTER //
// ../src/js/components/layout/KLCard/index.js